import { EmployeesService, GetEmployees_Out } from 'src/pehra-ts-client';
import styles from './EmployeeList.module.css';
import { Box, Button, Typography } from '@mui/material';
import EmployeeItem from '../EmployeeItem';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import EmployeeTable from 'src/pages/Employees/components/EmployeeTable';
import AddEmployeeViaOfficeModal from '../AddEmployeeViaOfficeModal';

export interface IEmployeeList {
  sampleTextProp?: string;
  officeId: string;
  data: GetEmployees_Out[];
}

const EmployeeList: React.FC<IEmployeeList> = ({ officeId, data }) => {
  const [openModal, setOpenModal] = useState<boolean>(false);

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <Box className={styles.container}>
      <Typography variant="h4" className={styles.title}>
        Employees
      </Typography>
      <Box className={styles.employeeListContainer}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginBottom: 2,
            width: '100%'
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setOpenModal(true);
            }}
          >
            Add Employee
          </Button>
        </Box>
        <EmployeeTable rows={data} />
      </Box>
      <Box>
        <AddEmployeeViaOfficeModal openModal={openModal} handleCloseModal={() => setOpenModal(false)} officeId={officeId} />
      </Box>
    </Box>
  );
};

export default EmployeeList;
